import { Env } from "./types";
import { nextJsEnv, reactNativeEnv } from "./config";

export class EnvFactory {
  static getValue<K extends keyof Env>(key: K): Env[K] {
    let env = reactNativeEnv;
    if (process.env.PLATFORM !== "MOBILE") {
      env = nextJsEnv;
    }
    return env[key];
  }
}
